<template>
    <div class="w-full md:p-5">
        <h2 class="text-2xl font-semibold mb-5">Частые вопросы</h2>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-x-5 md:gap-x-8 gap-y-5">
            <div
                v-for="(faq, idx) in faqs"
                :key="idx"
                class="w-full border-b border-gray-200 pb-3"
            >
                <h3 class="text-lg font-medium mb-3">
                    {{ idx + 1 }}. {{ faq.question }}
                </h3>
                <div class="text-sm text-gray-700 space-y-2">
                    <p v-for="(line, i) in faq.answer" :key="i">
                        {{ line }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import {ref} from 'vue'

const faqs = ref([
    {
        question: 'Насколько большой выбор в вашем магазине?',
        answer: [
            'Мы предлагаем широкий ассортимент плитки, чтобы каждый смог найти идеальный вариант под свой проект. Удобный фильтр поможет быстро подобрать нужный товар из каталога.'
        ]
    },
    {
        question: 'Как срочно вы можете доставить плитку?',
        answer: [
            'При заказе до 12:00 доставка возможна уже на следующий день.',
            'Минимальный срок — 1 день. Мы ценим ваше время и сделаем всё, чтобы плитка приехала в кратчайшие сроки.'
        ]
    },
    {
        question: 'Есть ли у вас недорогая плитка?',
        answer: [
            'Да. Помимо премиум-линейки, в ассортименте есть варианты отечественных и ближневосточных производителей с оптимальным соотношением цена/качество.'
        ]
    },
    {
        question: 'Я не смог дозвониться, вы перезвоните?',
        answer: [
            'Мы сами звоним клиентам, если по каким-то причинам не удалось связаться с вами при первоначальной попытке.',
            'Оставьте заявку на сайте или позвоните нам, и менеджер всегда перезвонит, даже если товара временно нет в наличии.'
        ]
    },
    {
        question: 'Нужно ли вносить предоплату?',
        answer: [
            'Предоплата не требуется — оплатите плитку при доставке удобным для вас способом.'
        ]
    },
    {
        question: 'Можно ли купить плитку с оплатой при получении?',
        answer: [
            'Да, мы поддерживаем оплату при получении — заказывайте онлайн 24/7 и оплачивайте курьеру по факту доставки.'
        ]
    },
    {
        question: 'У вас есть дисконтные карты?',
        answer: [
            'Да. При покупке вы получите дисконтную карту с накопительной системой скидок. Условия действуют на все последующие заказы.'
        ]
    },
    {
        question: 'Вам не хватило? Мы довезем!',
        answer: [
            'Если при укладке плитки окажется, что её не хватает, мы организуем довоз недостающих штук без лишних хлопот.',
            'Покупайте с запасом или заказывайте дополнительную партию — мы всегда поможем исправить ситуацию.'
        ]
    },
    {
        question: 'Не уверен, сколько плитки нужно, поможете рассчитать?',
        answer: [
            'Наши менеджеры подскажут, сколько плитки брать с учётом запаса на резку и брак.',
            'Оставьте детали по площади, и мы рассчитаем необходимый объём материала.'
        ]
    },
    {
        question: 'Можно ли вернуть товар?',
        answer: [
            'Возврат плитки принимается в течение 14 дней при условии сохранности упаковки и товарного вида.',
            'Хотя по закону плитка не подлежит обмену, мы идём навстречу клиентам и без проблем принимаем полный объём назад.'
        ]
    }
])
</script>

<style scoped>
/* можно добавить дополнительные стили, если нужно скорректировать отступы в колонках */
</style>
